import Vue from 'vue'

// 重置样式
import 'normalize.css/normalize.css'

// 复制到剪切板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// JS工具类
import loadsh from 'loadsh'
Vue.prototype._ = loadsh

const incomeCostNumberColumnPattern = /(price|money|amount|weight)/i
const incomeCostNumberTitlePattern = /(单价|金额|吨位|重量|载重|运价|合计|数量[（(]?吨|运费$|滞期费$|装卸费(?:6%)?$)/
Vue.prototype.$incomeCostTableCellClassName = ({ column }) => {
  const field = column.field || ''
  const title = column.title || ''
  return incomeCostNumberColumnPattern.test(field) || incomeCostNumberTitlePattern.test(title)
    ? 'income-cost-number-cell'
    : ''
}

const dayjs = require('dayjs')
const relativeTime = require('dayjs/plugin/relativeTime')
const quarterOfYear = require('dayjs/plugin/quarterOfYear');
const advancedFormat = require('dayjs/plugin/advancedFormat');
dayjs.extend(relativeTime)
dayjs.extend(quarterOfYear)
dayjs.extend(advancedFormat)
require('dayjs/locale/zh-cn')
dayjs.locale('zh-cn')
Vue.prototype.dayjs = dayjs

// nprogress进度条
import 'nprogress/nprogress.css'

// 完整导入 UI 组件库
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'

// 完整导入 表格库
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'

VxeUI.setConfig({
  emptyCell: '　',
  table: {
    size: 'mini',
    minHeight: 60
  },
  form: {
    size: 'mini'
  }
})

Vue.use(VxeUI)
Vue.use(VxeUITable)
